<template>
  <div id="add-new-order-modal">
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addNewOrderModal"
        persistent
        max-width="900px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitForm()"
          >
            <v-card-title>
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">{{ $t('orders.newOrderTitle') }}</span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeAddNewOrderModal(), $validator.reset()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                {{ $t('orders.itemOrderedSuccessfully') }}
              </v-alert>
              <v-alert
                type="error"
                :value="checkURL"
              >
                {{ $t('orders.urlFormatNotAcceptable') }}
              </v-alert>
              <v-layout wrap>
                <!-- <v-flex xs12>
                  <branch-select v-model="makeOrderData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="loggedInUserData.is_staff"
                >
                  <v-select
                    autocomplete
                    :items="customers"
                    item-text="text"
                    item-value="value"
                    v-model="makeOrderData.customer_id_fk"
                    :filter="filterCustomers"
                    :error-messages="errors.collect('customer_id_fk')"
                    data-vv-name="customer_id_fk"
                    :label="$t('columns.customer') + '*'"
                    v-validate="'required'"
                    single-line
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.productName') + '*'"
                    v-model="makeOrderData.product_name"
                    :error-messages="errors.collect('product_name')"
                    v-validate="'required'"
                    data-vv-name="product_name"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <history-autocomplete
                    v-model="makeOrderData.brand"
                    :items="brandHistory"
                    variant="vuetify"
                    :label="$t('columns.brand')"
                    data-vv-name="brand"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.productUrl') + '*'"
                    v-model="makeOrderData.product_url"
                    :error-messages="errors.collect('product_url')"
                    v-validate="'required'"
                    data-vv-name="product_url"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.quantity') + '*'"
                    v-model="makeOrderData.quantity"
                    :error-messages="errors.collect('quantity')"
                    v-validate="'required|numeric|min_value:1'"
                    data-vv-name="quantity"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="warehouses"
                    item-value="value"
                    v-model="makeOrderData.warehouse_id_fk"
                    :error-messages="errors.collect('warehouse_id_fk')"
                    data-vv-name="warehouse_id_fk"
                    :label="$t('columns.warehouse') + '*'"
                    v-validate="'required'"
                    @input="handleSelectWarehouse(makeOrderData.warehouse_id_fk)"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-select
                    :items="transportationTypes"
                    item-value="id"
                    item-text="name"
                    v-model="makeOrderData.transportation_type"
                    :error-messages="errors.collect('Transportation Type')"
                    data-vv-name="Transportation Type"
                    :label="$t('columns.transportationType') + '*'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.type')"
                    v-model="makeOrderData.type"
                    data-vv-name="type"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <history-autocomplete
                    v-model="makeOrderData.size"
                    :items="sizeHistory"
                    variant="vuetify"
                    :label="$t('columns.size')"
                    data-vv-name="size"
                  />
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('customer.color')"
                    v-model="makeOrderData.color"
                    data-vv-name="color"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  v-if="!makeOrderData.is_from_warehouse == 1"
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('columns.coupon')"
                    v-model="makeOrderData.coupon"
                    data-vv-name="coupon"
                  ></v-text-field>
                  <span
                    v-if="notCouponCode"
                    style="color: red"
                  >{{ $t('orders.couponCodeRequiredError') }}</span>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="isTurkeyWarehouse"
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '₺' })"
                    v-model="makeOrderData.the_tl_price"
                    type="number"
                    step="0.01"
                    min="0"
                    data-vv-name="the_tl_price"
                    placeholder="0.00"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="isUAEWarehouse"
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: 'AED' })"
                    v-model="makeOrderData.the_aed_price"
                    type="number"
                    step="0.01"
                    min="0"
                    data-vv-name="the_aed_price"
                    placeholder="0.00"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="isChinaWarehouse"
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '¥' })"
                    v-model="makeOrderData.the_cny_price"
                    type="number"
                    step="0.01"
                    min="0"
                    data-vv-name="the_cny_price"
                    placeholder="0.00"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="isGermanyWarehouse"
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '€' })"
                    v-model="makeOrderData.the_eur_price"
                    type="number"
                    step="0.01"
                    min="0"
                    data-vv-name="the_eur_price"
                    placeholder="0.00"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  v-if="!isTurkeyWarehouse && !isUAEWarehouse && !isChinaWarehouse && !isGermanyWarehouse"
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '$' })"
                    v-model="makeOrderData.item_price"
                    type="number"
                    step="0.01"
                    min="0"
                    data-vv-name="item_price"
                    placeholder="0.00"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                >
                  <v-text-field
                    :label="$t('orders.intShippingUsdLabel')"
                    v-model="makeOrderData.internal_shipping_handling"
                    type="number"
                    step="0.01"
                    min="0"
                    data-vv-name="internal_shipping_handling"
                    placeholder="0.00"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                >
                  <v-text-field
                    :label="$t('columns.note')"
                    v-model="makeOrderData.note"
                    data-vv-name="note"
                  >
                  </v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                >
                  <v-text-field
                    :label="$t('orders.imageUrlOptionalLabel')"
                    v-model="makeOrderData.image_url"
                    :error-messages="errors.collect('image_url')"
                    v-validate="'url'"
                    data-vv-name="image_url"
                    placeholder="https://example.com/image.jpg"
                    @input="clearFileOnUrlInput"
                    :disabled="makeOrderData.image !== null"
                  >
                  </v-text-field>
                  <span v-if="makeOrderData.image_url" style="color: #4CAF50; font-size: 12px;">
                    {{ $t('orders.urlWillBeUsedInsteadHint') }}
                  </span>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm3
                >
                  <v-checkbox
                    :label="$t('customer.repackage')"
                    v-model="makeOrderData.is_repackage"
                    class="ma-0 pa-0 mt-4"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm2
                >
                  <v-checkbox
                    :label="$t('delivery.holdStatus')"
                    v-model="makeOrderData.is_hold"
                    class="ma-0 pa-0 mt-4"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  v-if="$_has_perm('send_order_to_purchase')"
                  class="px-2"
                  xs12
                  sm3
                >
                  <v-checkbox
                    :label="$t('orders.sendToPurchaseLabel')"
                    v-model="makeOrderData.send_to_purchase"
                    class="ma-0 pa-0 mt-4"
                  ></v-checkbox>
                </v-flex>

                <v-flex
                  v-if="$_has_perm('send_order_to_purchase') && makeOrderData.send_to_purchase"
                  class="px-2"
                  xs12
                  sm4
                >
                  <v-select
                    :items="banks"
                    item-text="text"
                    item-value="value"
                    v-model="makeOrderData.bank_id"
                    :label="$t('orders.purchaseBankLabel') + '*'"
                    :error-messages="errors.collect('Purchase Bank')"
                    v-validate="'required'"
                    data-vv-name="Purchase Bank"
                  ></v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm7
                >
                  <v-text-field
                    :label="$t('orders.otherServiceSpecifyLabel')"
                    v-model="makeOrderData.other_service"
                    data-vv-name="other_service"
                  >
                  </v-text-field>
                </v-flex>

                <div class="col-md-12 d-flex align-items-center">
                  <!-- <div class="col-md-1" v-if="imagePreview" style="margin-right: 15px;"> -->
                    <img
                    :src="makeOrderData.image_url ? makeOrderData.image_url : (makeOrderData.image ? imagePreview : '../../assets/images/shipzone.png')"
                    :alt="$t('columns.preview')"
                    style="width: 70px; height: 70px; object-fit: cover; border: 1px solid #ccc; flex:none !important"
                    @error="handleImageError"
                  />
                <!-- </div> -->
                <v-btn
                  block
                  @click="triggerFileInput"
                  :disabled="makeOrderData.image_url !== '' && makeOrderData.image_url !== null"
                  style="margin: 16px;max-width: 300px; display: flex; align-items: center; justify-content: center;"
                >
                  {{ $t('orders.uploadImage') }}
                </v-btn>
                <span
                  v-if="makeOrderData.fileName"
                  style="display: flex; align-items: center;" class="rtl-ml-15"
                >
                  {{ makeOrderData.fileName }}
                </span>
                <input
                  type="file"
                  ref="fileInput"
                  style="display: none"
                  accept="image/*"
                  v-validate="'max_file_size:50|allowed_image_type'"
                  data-vv-name="file"
                  @change="handleFileUpload"
                />
                <div v-if="errors.has('file')" style="color: red; display: block; margin-top: 5px;">
                  {{ errors.first('file') }}
                </div>
              </div>
              </v-layout>
              <!--<div>-->
              <!--<h5 class="lead">-->
              <!--</h5>  -->
              <!--</div>-->
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeAddNewOrderModal(), $validator.reset()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >{{ $t('common.add') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
  <!-- c_o_d -->
</template>
<script>
import axios from 'axios'
import { Validator } from 'vee-validate'
import { isAllowedImageExtension, ALLOWED_IMAGE_EXTENSIONS } from '../mixins/helpers'
import HistoryAutocomplete from './HistoryAutocomplete.vue'
import i18n from '../lang'

Validator.extend('max_file_size', {
  getMessage: (field, params) => i18n.t('orders.fileSizeExceedsError', { field, size: params[0] }),
  params: ['size'],
  validate(value, args) {
    if (!value || !value.length) return true // No file selected
    const file = value[0]
    const size = parseFloat(args[0]) // Convert parameter to number
    if (!file || !file.size) return false
    return file.size <= size * 1024 * 1024 // Convert MB to bytes
  }
})

Validator.extend('allowed_image_type', {
  getMessage: () => i18n.t('orders.unsupportedImageTypeShort', { allowed: ALLOWED_IMAGE_EXTENSIONS.join(', ').toUpperCase() }),
  validate(value) {
    if (!value || !value.length) return true // No file selected
    const file = value[0]
    if (!file || !file.name) return false
    return isAllowedImageExtension(file.name)
  }
})

export default {
  components: {
    HistoryAutocomplete
  },

  created() {
    this.getLoggedInUser()
    this.fetchBrandHistory()
    this.fetchSizeHistory()
  },

  props: [
    'addNewOrderModal',
    'warehouses',
    'closeAddNewOrderModal',
    'checkAlert',
    'deliveryTypes',
    'makeOrderData',
    'makeNewOrder',
    'customers',
    'checkURL',
    'loading',
    'banks'
  ],

  data() {
    return {
      loggedInUserData: {},
      notCouponCode: false,
      transportationTypes: [],
      imagePreview: null,
      brandHistory: [],
      sizeHistory: []
    }
  },

  computed: {
    selectedWarehouseCurrency() {
      if (!this.makeOrderData.warehouse_id_fk || !this.warehouses) return null
      const warehouse = this.warehouses.find(w => w.value === this.makeOrderData.warehouse_id_fk)
      return warehouse ? warehouse.currency : null
    },

    isTurkeyWarehouse() {
      if (!this.makeOrderData.warehouse_id_fk || !this.warehouses) return false
      const warehouse = this.warehouses.find(w => w.value === this.makeOrderData.warehouse_id_fk)
      return warehouse ? (warehouse.text || '').toLowerCase().includes('turkey') : false
    },

    isUAEWarehouse() {
      if (!this.makeOrderData.warehouse_id_fk || !this.warehouses) return false
      const warehouse = this.warehouses.find(w => w.value === this.makeOrderData.warehouse_id_fk)
      const name = (warehouse ? warehouse.text || '' : '').toLowerCase()
      return name.includes('uae') || name.includes('emirat')
    },

    isChinaWarehouse() {
      if (!this.makeOrderData.warehouse_id_fk || !this.warehouses) return false
      const warehouse = this.warehouses.find(w => w.value === this.makeOrderData.warehouse_id_fk)
      return warehouse ? (warehouse.text || '').toLowerCase().includes('china') : false
    },

    isGermanyWarehouse() {
      if (!this.makeOrderData.warehouse_id_fk || !this.warehouses) return false
      const warehouse = this.warehouses.find(w => w.value === this.makeOrderData.warehouse_id_fk)
      return warehouse ? (warehouse.text || '').toLowerCase().includes('germany') : false
    }

  },

  watch: {
    warehouses: {
      handler(newWarehouses) {
        if (newWarehouses && newWarehouses.length > 0 && !this.makeOrderData.warehouse_id_fk) {
          const turkey = newWarehouses.find(w => (w.text || '').toLowerCase().includes('turkey'))
          const defaultWarehouse = turkey || newWarehouses[0]
          this.makeOrderData.warehouse_id_fk = defaultWarehouse.value
          this.handleSelectWarehouse(defaultWarehouse.value)
        }
      },
      immediate: true
    }
  },

  methods: {
    filterCustomers(item, queryText, itemText) {
      const query = String(queryText || '').toLowerCase().trim()
      if (!query) return true

      const visibleFields = [
        itemText,
        item && item.full_name,
        item && item.phone_number,
        item && item.phone_number_2
      ]
        .filter(Boolean)
        .map(value => String(value).toLowerCase())

      if (visibleFields.some(value => value.includes(query))) {
        return true
      }

      const normalizedQuery = this.normalizePhoneSearch(query)
      if (!normalizedQuery) {
        return false
      }

      return [item && item.phone_number, item && item.phone_number_2]
        .filter(Boolean)
        .some(value => this.normalizePhoneSearch(value).includes(normalizedQuery))
    },

    normalizePhoneSearch(value) {
      return String(value || '').replace(/\D/g, '')
    },

    handleSelectWarehouse(id) {
      this.makeOrderData.transportation_type = null
      const warehouse = this.warehouses.find(w => w.value === id)

      if (warehouse) {
        this.transportationTypes = warehouse.transportation_types
        // Auto-select first transportation type
        if (this.transportationTypes && this.transportationTypes.length > 0) {
          this.makeOrderData.transportation_type = this.transportationTypes[0].id
        }
      }
    },

    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    handleFileUpload(event) {
      this.makeOrderData.image = null
      this.makeOrderData.fileName = ''
      const file = event.target.files[0]

      if (!file) {
        this.$validator.errors.remove('file')
        this.file = null
        this.imagePreview = null
        return
      }

      // Validate against the actual selected file and wait for the result -
      // checking this.errors synchronously here would race the async v-validate rules.
      this.$validator.validate('file', event.target.files).then(isValid => {
        if (isValid) {
          this.file = file
          this.makeOrderData.image = file
          this.makeOrderData.fileName = file.name
          this.imagePreview = URL.createObjectURL(file)
          // Clear URL when file is selected
          this.makeOrderData.image_url = ''
        } else {
          this.file = null
          this.makeOrderData.image = null
          this.imagePreview = null
          event.target.value = ''
        }
      })
    },

    clearFileOnUrlInput() {
      if (this.makeOrderData.image_url && this.makeOrderData.image_url.trim() !== '') {
        this.makeOrderData.image = null
        this.makeOrderData.fileName = ''
        this.imagePreview = null
        this.$refs.fileInput.value = ''
      }
    },

    handleImageError(event) {
      // Fallback to default image if URL fails to load
      event.target.src = '../../assets/images/shipzone.png'
    },

    submitForm() {
      this.$validator.validateAll().then(res => {
        if (res) {
          // Default to 0 when left blank instead of sending an empty string
          // (which the backend's ConvertEmptyStringsToNull middleware turns into
          // null, leaving int. shipping unset on the order).
          const shipping = Number(this.makeOrderData.internal_shipping_handling)
          this.makeOrderData.internal_shipping_handling = Number.isFinite(shipping) ? shipping : 0
          // Copy local currency price to item_price so backend can convert to USD
          if (this.isTurkeyWarehouse) {
            this.makeOrderData.item_price = this.makeOrderData.the_tl_price
          } else if (this.isUAEWarehouse) {
            this.makeOrderData.item_price = this.makeOrderData.the_aed_price
          } else if (this.isChinaWarehouse) {
            this.makeOrderData.item_price = this.makeOrderData.the_cny_price
          } else if (this.isGermanyWarehouse) {
            this.makeOrderData.item_price = this.makeOrderData.the_eur_price
          }
          // Auto-derive brand from first two words of product name if brand is empty
          if (!this.makeOrderData.brand || !this.makeOrderData.brand.trim()) {
            const words = (this.makeOrderData.product_name || '').trim().split(' ')
            this.makeOrderData.brand = [words[0] || '', words[1] || ''].join(' ').trim()
          }
          this.rememberBrandAndSize()
          if (this.makeOrderData.coupon && this.makeOrderData.coupon.length) {
            if (this.makeOrderData.coupon.substr(0, 4) === 'SHZ-') {
              this.notCouponCode = false
              this.makeNewOrder()
            } else {
              this.notCouponCode = true
            }
          } else {
            this.notCouponCode = false
            this.makeNewOrder()
          }
        }
      })
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    fetchBrandHistory() {
      let token = localStorage.getItem('access_token')
      axios.get('api/order-brand-history', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => { this.brandHistory = response.data.data || [] })
        .catch(() => { this.brandHistory = [] })
    },

    fetchSizeHistory() {
      let token = localStorage.getItem('access_token')
      axios.get('api/order-size-history', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => { this.sizeHistory = response.data.data || [] })
        .catch(() => { this.sizeHistory = [] })
    },

    rememberBrandAndSize() {
      const brand = this.makeOrderData.brand
      if (brand && !this.brandHistory.some(b => b.toLowerCase() === brand.toLowerCase())) {
        this.brandHistory.unshift(brand)
      }
      const size = this.makeOrderData.size
      if (size && !this.sizeHistory.some(s => s.toLowerCase() === size.toLowerCase())) {
        this.sizeHistory.unshift(size)
      }
    }

  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/addNewOrder.vue